<template>
    <div class="attr_dialog branch_attr" v-if="curProps">
        <div class="attr_head">
            <el-form ref="form" label-width="40px" class="attr_common" label-position="left">
                <el-form-item label="ID:">
                    <el-input v-model="curProps.id" type="number"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-array">
                <el-button type="primary" icon="el-icon-check" size="mini" @click="saveProps">保存</el-button>
                <el-button type="primary" icon="el-icon-close" size="mini" @click="resetProps">恢复默认</el-button>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 节点属性编辑框
 */
import { mapState } from 'vuex';

export default {
    name:"pressure_attr",
    computed:{
        ...mapState('simulation',[
            'drawSource', // 绘制图层
        ]),
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
    },
    data(){
        return {
            curProps:{} , // 当前属性
        }
    },
    mounted(){
        // 初始化属性
        this.$nextTick(()=>{
            this.init_props()
        })
    },
    methods:{
        // 初始化属性
        init_props(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};
            let props={};

            props.id=nodeProps.id;
            
            this.curProps=props;
        },
        // 保存修改的属性
        saveProps(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};
            // 修改id号  
            let id=this.curProps.id;
            if(this.checkId(id)){
                this.$message({
                    message:"编号已存在",
                    type:"error",
                    duration:2000
                });
                return;
            }

            nodeProps.id=parseInt(id);

            // 重新应用属性
            this.curFeature.setProperties(nodeProps);
            // 属性版本号增加
            let versionid=nodeProps.version||1;
            versionid=versionid+1;
            this.curFeature.set("version",versionid);



            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });

            // 关闭对话框
            this.$emit("close");

        },
        // 重置属性
        resetProps(){
            // 重新获取属性
            this.init_props();
        },
        // id号判断
        checkId(id){
            let source=this.drawSource;
            let features=source.getFeatures();
            let result=false;
            features.forEach(f=>{
                let _type=f.get("_type");
                // 判断当前图形是不是节点
                if(_type!="line"){
                    let nodeid=f.get("id");
                    if(nodeid==id&&this.curFeature!=f){
                        result=true;
                        return;
                    }
                }
            });
            return result;
        }
    }
}
</script>

<style lang="scss">
.branch_attr{
    position: relative;
    height: 200px;

    .attr_head{
        overflow: hidden;

        .attr_common{
            width:250px;
            float: left;
        }

        .btn-array{
            position:relative;
            float:right;

            button{
                display: block;
                margin-top: 8px;
                margin-left: 0;
                padding: 5px 3px;
                width: 90px;
                span{
                    cursor: pointer;
                }
            }

            button:first-child{
                margin-top:0;
            }
        }

        .el-input__inner{
            line-height: 35px;
            height: 35px;
        }
    }
    
}
</style>